import { render, staticRenderFns } from "./ModalContentMassEmail.vue?vue&type=template&id=50f66e66&scoped=true&"
import script from "./ModalContentMassEmail.vue?vue&type=script&lang=js&"
export * from "./ModalContentMassEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentMassEmail.vue?vue&type=style&index=0&id=50f66e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f66e66",
  null
  
)

export default component.exports